import { actions } from './slices';
import { checkVoucherValidityAsync } from './thunks';

export const VouchersActions = {
  ...actions,
  checkVoucherValidityAsync,
};
